import { Input, InputElement } from "../../../../common/components";
import { GetInputOptions } from "../getInput";
import React from "react";
import getTranslatedValue from "../../../../utils/CustomerTranslations/getTranslatedValue";
export const getTextInput = ({
  error,
  question,
  onChange,
  value,
  tCustomer
}: GetInputOptions) => {
  const {
    name,
    required
  } = question;
  const id = question.id ?? name;
  const label = getTranslatedValue(`customQuestion.${id}`, "name", tCustomer, question);

  // Shouldn't be possible, but just in case of bad data and mostly for TS
  if (typeof value === "boolean") throw new Error(`Type mismatch on value of question ${id}. Expected string, received boolean.`);
  const onValueChange = (event: React.ChangeEvent<InputElement>) => onChange({
    id,
    newValue: event.target.value
  });
  return <Input variant="text" onChange={onValueChange} label={label} id={id} error={error} required={required} value={value ?? ""} data-sentry-element="Input" data-sentry-component="getTextInput" data-sentry-source-file="getTextInput.tsx" />;
};